import React from 'react'
import PropTypes from 'prop-types'
import style from './index.scss'
import Half from './half'

const HalfHalf = ({ children }) => (
  <div className={style.HalfHalf}>{children}</div>
)

HalfHalf.propTypes = {
  children: PropTypes.node,
}

export { Half, HalfHalf }
